// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"cf995aec","967":"67d3cb31"}[chunkId] + ".chunk.js";
};